/** @format */
import { post } from '@root/utils/httpWrap';
import { Component, Mixins, Vue } from 'vue-property-decorator';
import uploadConfig from './uploadConfig.js';
@Component({
  components: {
    fileImport: Vue.component('bd-upload', {
      data() {
        return {
          selectedFileList: [],
          uploadInstance: new uploadClass(),
          uploading: false
        };
      },
      // mounted() {
      //   console.log('longRentalCarRef--:', this.$parent)
      // },
      methods: {
        // successFunName: {
        //   type: String,
        //   default: 'fetchTableData',
        // },
        // handler: {
        beforeUpload(file: any) {
          this.selectedFileList = [file];
          console.log('this and file list--:', this, this.selectedFileList);
          return false;
        },
        doUpload() {
          console.log('this--:', this, arguments);
          const { selectedFileList } = this;
          const formData = new FormData();
          selectedFileList.forEach(file => {
            formData.append(this.antConfig.multiple ? 'files[]' : 'file', file);
          });
          this.uploading = true;
          const load = this.$message.loading('导入中,请稍等', 0);
          let res = post(this.uploadInstance.uploadConfig[this.fileType].urls[this.moduleName], formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            },
            timeout: 60000
          });
          res.then(() => {
            load();
            this.$message.success('导入成功');
            this.$emit('success');
            this.uploading = false;
          });
          res.catch(e => {
            load();
            this.$message.error(e.msg);
            this.uploading = false;
            this.$emit('error', e);
          });

          // You can use any AJAX library you like
          // reqwest({
          //   url: this.uploadInstance,
          //   method: 'post',
          //   processData: false,
          //   data: formData,
          //   success: () => {
          //     this.selectedFileList = []
          //     this.uploading = false
          //     this.$message.success('upload successfully.')
          //   },
          //   error: () => {
          //     this.uploading = false
          //     this.$message.error('upload failed.')
          //   },
          // })
        }
        // },
        // invoke(actionName, ...args) {
        //   console.log('uploadInstance--', this.uploadInstance)
        //   return this.uploadInstance[actionName].call(this)
        // },
      },
      props: {
        vm: Object,
        antConfig: {
          type: Object,
          default() {
            return {};
          }
        },
        buttonText: {
          default: '导入',
          type: String
        },
        moduleName: {
          default: 'common',
          type: String
        },
        fileType: {
          default: 'excel',
          type: String
        },
        buttonType: {
          default: 'primary',
          type: String
        },
        buttonAuthorizedName: {
          default: '',
          type: String
        }
      },
      template: `
      <Authorized v-if="buttonAuthorizedName" :resource="buttonAuthorizedName" behavior="none">
      <a-upload 
      :beforeUpload="beforeUpload"
      :disabled="uploading"
      :showUploadList="false"
      @change="doUpload"
      style="display:inline-block;margin-right:20px;"
      :name="antConfig.name||'file'"
      :multiple="antConfig.multiple||false"
    >
    <Authorized :resource="buttonAuthorizedName">
      <a-button :type="buttonType"> <a-icon type="cloud-upload" /> {{uploading?'导入中...':buttonText}} </a-button>
    </Authorized>
    </a-upload>
      </Authorized>
     <a-upload v-else
     :disabled="uploading"
     :beforeUpload="beforeUpload"
     :showUploadList="false"
     @change="doUpload"
     style="display:inline-block;margin-right:20px;"
     :name="antConfig.name||'file'"
     :multiple="antConfig.multiple||false"
   >
     <a-button :type="buttonType"> <a-icon type="cloud-upload" /> {{uploading?'导入中...':buttonText}}</a-button>
   </a-upload>
      `
    })
  }
})
class uploadClass extends Vue {
  headers = {};
  uploadConfig = uploadConfig;
}

export default uploadClass;
